/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useState, useMemo, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateAdminConfig } from 'state/thunks/commenting';
// material
import ConfigV2Controller from 'material/expandablesection/v2/configv2controller/configv2controller'
import ExpandableSection from 'material/expandablesection/expandablesection'
import { ReactComponent as PersonLockIcon } from 'assets/icons/person-lock.svg'
// content
import CommentVolume from './commentvolume/commentvolume'
import ShareEmailWithFreestar from './shareemailwithfreestar/shareemailwithfreestar'
// styles
import injectSheet from 'react-jss'
import styles from './adminsection_styles'
import { setTempCommentingUnitConfig } from 'state/slices/commentingv2';


/* ========== ~~~~~~~~~~ COMMENTING CONFIG V2: ADMIN SECTION ~~~~~~~~~~ ========== */
const AdminSection = injectSheet(styles)((props) => {

  const dispatch = useDispatch()
  const { adminConfig: savedAdminConfig, commentingUnitId } = useSelector(state => state.commentingV2.commentingUnitConfig)
  const { adminConfig: tempAdminConfig } = useSelector(state => state.commentingV2.tempCommentingUnitConfig)

  const [adminConfig, setAdminConfig] = useState(savedAdminConfig)
  const [isOpened, setIsOpened] = useState(false)

  // useEffect(() => {
  //   if(adminConfig !== savedAdminConfig && !isOpened) setAdminConfig(savedAdminConfig)
  // }, [savedAdminConfig, isOpened, adminConfig])

  const handleToggle = () => setIsOpened(!isOpened)

  const handleSave = useCallback(async (e) => {
    e.stopPropagation()
    const response = await dispatch(updateAdminConfig({ adminConfig, commentingUnitId }))
    if(response.payload && !response.payload.error) setIsOpened(false)
  }, [dispatch, adminConfig, commentingUnitId])

  const handleCancel = useCallback(async () => {
    setIsOpened(false)
    setAdminConfig(savedAdminConfig)
    dispatch(setTempCommentingUnitConfig({
      configName: 'adminConfig',
      data: savedAdminConfig
    }))
  }, [dispatch, savedAdminConfig])

  const isChanged = useMemo(() => {
    const isFieldsChanged = !(JSON.stringify(tempAdminConfig) === JSON.stringify(savedAdminConfig));
    return isFieldsChanged
  }, [tempAdminConfig, savedAdminConfig])


  const handleAdminConfigChange = useCallback((property, value) =>{
      setAdminConfig({
        ...adminConfig,
        [property]: value
      })
      dispatch(setTempCommentingUnitConfig({
        configName: 'adminConfig',
        data: {
          ...adminConfig,
          [property]: value
        }
      }))
  }, [dispatch, adminConfig]);

  const adminConfigData = useMemo(() => {
    return {
      commentVolume: {
        commentVolume: adminConfig.commentVolume
      },
      shareEmailWithFreestar: {
        shareEmailWithFreestar: adminConfig.shareEmailWithFreestar
      }
    }
  }, [adminConfig])


  const controller = (
    <ConfigV2Controller
      isOpened={isOpened}
      handleToggle={handleToggle}
      handleCancel={handleCancel}
      handleSave={handleSave}
      isProcessing={savedAdminConfig.isUpdating}
      disableSave={!isChanged}
      saveTitle={'Save Changes'}
      icon={<PersonLockIcon />}
      title='Admin'
    />
  );

  return (
    <ExpandableSection
      className={`expandablesectionv2 adminsection ${props.classes.adminsection}`}
      controller={controller}
      isOpened={isOpened}
      handleToggle={handleToggle}
      handleCancel={handleCancel}
      handleSave={handleSave}
      isProcessing={savedAdminConfig.isUpdating}
      disableSave={!isChanged}
    >
      <CommentVolume onChange={handleAdminConfigChange} {...adminConfigData.commentVolume} />
      <ShareEmailWithFreestar onChange={handleAdminConfigChange} {...adminConfigData.shareEmailWithFreestar} />
    </ExpandableSection>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default AdminSection;